import { gsap } from 'gsap'; 
// import {throttle} from '../helper/util';
import { throttle } from 'throttle-debounce';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const canHover = window.matchMedia('(hover: hover)').matches;

const heroVid = {
	init() {
    let heroVids = document.querySelectorAll('.js-hero-vid');
    if (heroVids.length > 0) {
      heroVids.forEach(function(vid) {	
        gsap.to(vid, 1, {opacity: 1});
        vid.play();
      });
    }
  },
}

const videoHover = {
	init() {

    if (canHover === true) {

      var parents = document.querySelectorAll('.js-video-hover');

      parents.forEach(function(parent) {	
        
        const vidWrapper = parent.querySelector('.js-video-hover-item');
        if (vidWrapper){

          const vid = vidWrapper.querySelector('video');
          const vidSrc = vid.dataset.src;
          const img = parent.querySelector('img');
          const vidTL = gsap.timeline({paused: true});
          
          vidTL.fromTo(vidWrapper, 0.3, {opacity: 0},{opacity: 1}, 0.5);
          // vid.play()
          // vid.pause()
          
          parent.addEventListener('mouseenter', () => {  
            throttleVidMouseEnter(1);
          });
          parent.addEventListener('mouseleave', () => {  
            throttleVidMouseLeave(1);
          });        
          
          // parent.addEventListener('mouseleave', vidLeave);
          const throttleVidMouseEnter = throttle(150, (num) => {
            vidEnter();
          });
          const throttleVidMouseLeave = throttle(150, (num) => {
            vidLeave();
          });        
          
          parent.addEventListener('click', function(event){
            parent.removeEventListener('mouseenter', vidEnter);  
            parent.removeEventListener('mouseleave', vidLeave);       
            gsap.to(vid, 0.5, {opacity: 0});
          });          
    
          async function vidSrcSet() {
            vid.src = vidSrc;
          }
          function vidPlay() {
            vid.play();
            vidTL.play();
            // gsap.to(vidWrapper, 1, {opacity: 1});
            // gsap.to(img, 1, {opacity: 0});
          }            
            
          function vidEnter(){
            if (vid.getAttribute('src') == null){
              vidSrcSet().then(() => {
                vidPlay();
              });
            } else {
              vidPlay();
            }
          }
          function vidLeave(){
            vid.pause();
            vidTL.reverse();
            // gsap.to(vidWrapper, 0.5, {opacity: 0});
            // gsap.to(img, 0.5, {opacity: 1});
          }        
        }

      
      });      

    }  

	},
};
const videoHero = {
	init() {

    var vidHeros = document.querySelectorAll('.js-hero-video');

    vidHeros.forEach(function(vidHero) {	
      
        const vid = vidHero.querySelector('video');
        const vidSrc = vid.dataset.src;
        // const img = parent.querySelector('.js-featured-project-img');
        
        async function vidSrcSet() {
          vid.src = vidSrc;
        }
        function vidPlay() {
          vid.play();
          setTimeout(function() {
            gsap.to(vidHero, 1, {opacity: 1}, 3);
          }, 500);
        }            
        function vidInit(){
          vidSrcSet().then(() => {
            vid.addEventListener('loadeddata', function() {
              vidPlay();
            }, false);
          });
        }
        setTimeout(vidInit, 2000);

    });        

	},
};

const videoPlay = {
	init() {

    var videos = document.querySelectorAll('.js-video');
    const playIconWrapper = document.querySelector('.js-icon-play');
    const playIconInner = playIconWrapper.querySelector('.play');               // black triangle 
    const playIconLoading = playIconWrapper.querySelector('.loading-circles');  // group 3x circles 
    const playIconLoadingCircles = playIconLoading.querySelectorAll('circle');  // 3x circles 

    videos.forEach(function(video) {	

      let vid = video.querySelector('video');
      let vidSrcSD = vid.dataset.vidsd;
      let vidSrcHD = vid.dataset.vidhd;

      function checkSize() {
        if (document.querySelector('html').clientWidth > 768) {
          // vid.removeAttribute("src");
          vid.setAttribute("src", vidSrcHD);
        } else {
          vid.setAttribute("src", vidSrcSD);
        }
      }
      
      if (vidSrcHD != '' && vidSrcSD != '') {      
        checkSize(); 
        window.addEventListener("resize", function(){
          throttleResizeCheckSize(1);
          gsap.set(document.querySelector('.js-icon-play'), {opacity: 0});
        });
        const throttleResizeCheckSize = throttle(2000, (num) => {
            checkSize(); 
            pauseVideo();
        });
      } else if (vidSrcSD != '') {
        vid.setAttribute("src", vidSrcSD);
      }

      video.addEventListener('click', handlePlayButton, false);
    
      const loadingTl = gsap.timeline({ paused: true });
      const loadingRepeatTl = gsap.timeline({ paused: true, repeat:-1, repeatDelay: 0 });
      //
      // Fade in circles
      //
      loadingTl.fromTo(playIconLoading, 0.3, {
        opacity: 0,
      },{
        opacity: 1,
        ease: 'power2.in'
      })
      .fromTo(playIconLoadingCircles, 0.15, {
        opacity: 0,
      },{
        opacity: 1,
        stagger: 0.15,
        ease: 'power2.in',
      });
      //
      // Repeat move circles up and down
      // 
      loadingRepeatTl.fromTo(playIconLoadingCircles, 0.3, {
        y: -10,
      },{
        y: 0,
        ease: 'power4.out',
        stagger: 0.1
      })
      .fromTo(playIconLoadingCircles, 0.3, {
        y: 0,
      },{
        y: -10,
        ease: 'power4.in',
        stagger: 0.1,   
      }, '+=0.2')
      ;      

      async function playVideo() {                    
        try {
          console.log('before await');
          video.classList.add('playing');
          gsap
            .to(playIconInner, 0.2, {opacity: 0})
          ;
          loadingTl.play();
          loadingRepeatTl.play();          
          await vid.play();
          // vid.pause()
          setTimeout(()=> {
            gsap.to(playIconWrapper, 0.2, {opacity: 0});                             
            gsap.to(playIconLoading, 0.2, {opacity: 0});                             
            gsap.to(playIconLoadingCircles, 0.2, {opacity: 0});                             
            loadingTl.pause();
            loadingRepeatTl.pause();
          }, 800);          
          if (canHover === true) {
            vid.setAttribute('controls', '');
          }
        } 
        catch (err) {
        }
      }
      async function pauseVideo() {                    
        try {
          await vid.pause();
          video.classList.remove('playing');
          if (canHover === true) {
            vid.removeAttribute('controls');
          }
        } 
        catch (err) {
        }
      }      
        
      function handlePlayButton() {

        if (vid.paused) {
            playVideo();
          } else {
            pauseVideo();            
            // if ((playIconWrapper.style.opacity != 0) && (playIconWrapper.style.display != 'none')) {
            gsap.to(playIconWrapper, 0.6, {opacity: 1, scale: 1, ease: 'power4.in'});
            gsap.to(playIconInner, 0.4, {opacity: 1, ease: 'power2.in'});
            gsap.to(playIconLoading, {opacity: 0});
            // }            
        }
      }                
      vid.addEventListener('pause', () => {
        console.log('pause');
        vid.classList.remove('playing');
      }); 
      vid.addEventListener('play', () => {
        if (canHover === true) {
          video.removeEventListener('click', handlePlayButton, false);
        }
      });             
    
    });        

	},
};

const autoplayVideo = {
	init() {

    var videos = document.querySelectorAll('.js-autoplay-video');

    videos.forEach(function(video) {	
      
      ScrollTrigger.create({
        trigger: video,
        start: "top bottom",
        end: "bottom top",
        onEnter: self => video.play(),
      });        

      // async function playVideo() {                    
      //   try {
      //     await vid.play();
      //     vid.setAttribute('controls', '');
      //     video.classList.add('playing');
      //     gsap.to(playIconWrapper, 0.2, {opacity: 0, scale: 0.5});            
      //   } 
      //   catch (err) {
      //   }
      // }
      // async function pauseVideo() {                    
      //   try {
      //     await vid.pause();
      //     video.classList.remove('playing');
      //     vid.removeAttribute('controls');
      //   } 
      //   catch (err) {
      //   }
      // }      
        
      // function handlePlayButton() {

      //   if (vid.paused) {
      //       playVideo();
      //   } else {
      //       pauseVideo();
      //       // if ((playIconWrapper.style.opacity != 0) && (playIconWrapper.style.display != 'none')) {
      //       gsap.to(playIconWrapper, 0.6, {opacity: 1, scale: 1, ease: 'power4.in'});
      //       // }            
      //   }
      // }                
      // vid.addEventListener('pause', () => {
      //   vid.classList.remove('playing');
      // });       
    
    });        

	},
};

const playMouseFollow = {
	init() {
    
    if (canHover === true) {

      var videos = document.querySelectorAll('.js-video');
      const playIconWrapper = document.querySelector('.js-icon-play');
      const playIconInner = playIconWrapper.querySelector('.play');

      if (videos.length > 0){

          const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
          const mouse = { x: pos.x, y: pos.y };
          const speed = 0.2;
          const scale = 0.5;
          const duration1 = 0.4;
          const duration2 = duration1*0.5;            
          
          videos.forEach(function(video) {	  

              gsap.set(playIconWrapper, {xPercent: -50, yPercent: -50});
  
              // playIconWrapper.style.display = 'block';
              playIconWrapper.style.opacity = '0';
                  
              const xSet = gsap.quickSetter(playIconWrapper, 'x', 'px');
              const ySet = gsap.quickSetter(playIconWrapper, 'y', 'px');
              
              window.addEventListener('mousemove', e => {    
                  mouse.x = e.clientX;
                  mouse.y = e.clientY;  
              });

              gsap.ticker.add(() => {
            
                  // adjust speed for higher refresh monitors
                  const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio()); 
                  
                  pos.x += (mouse.x - pos.x) * dt;
                  pos.y += (mouse.y - pos.y) * dt;
                  xSet(pos.x);
                  ySet(pos.y);
      
              });          
              
              const tlEnter = gsap.timeline({ paused: true });
              // const tlLeave = gsap.timeline({ paused: true });

              gsap.set(playIconWrapper, {scale: scale, opacity: 0});

              tlEnter
              .set(playIconInner, {opacity: 1})
              .fromTo(playIconWrapper, duration1, {
                  scale: scale,
              },
              {
                  scale: 1,
                  ease: 'back.out(1.7)',
              }, 0.2)
              .fromTo(playIconWrapper, duration2, {
                  opacity: 0,
              },{
                  opacity: 1,
                  // immediateRender: false
              }, 0.2);   

              // tlLeave.fromTo(playIconWrapper, duration2*0.5, {
              //     scale: 1
              // },
              // {
              //     scale: scale,
              //     ease: 'power3.inOut',
              //     // immediateRender: false
              // }, 0)
              // .to(playIconWrapper, duration2*0.5, {
              //     opacity: 0,
              // }, 0);   
                            
              // video.addEventListener('mouseenter', function () {
              //   throttleMouseEnter(1);     
              // });               
              // video.addEventListener('mouseleave', function () {
              //   throttleMouseLeave(1);     
              // });                               
              // const throttleMouseEnter = throttle(100, (num) => {
              //   if (video.classList.contains('playing')){
              //     // return tlEnter.reverse();  
              //   } else {
              //     return tlEnter.play(0);
              //   }             
              // });  
              // const throttleMouseLeave = throttle(100, (num) => {
              //   if (video.classList.contains('playing') == false){
              //     return tlEnter.reverse();
              //   }                        
              // });  
              video.addEventListener('mouseenter', function () {
                if (video.classList.contains('playing')){
                  // return tlEnter.reverse();  
                } else {
                  return tlEnter.play(0);
                }             
              });               
              video.addEventListener('mouseleave', function () {
                if (video.classList.contains('playing') == false){
                  return tlEnter.reverse();
                }                        
              });                               

          });        

      }
    }
	},
};


export {videoHero, videoHover, videoPlay, autoplayVideo, heroVid, playMouseFollow};